// Column definitions for the Career Connect jobs data grid.
// Plain MUI DataGrid column objects (field / headerName / width / valueGetter),
// matching the project convention (see assetmanagement/VendorTableHead).

// job_status codes -> readable labels
const JOB_STATUS_LABEL = {
  0: "Draft",
  1: "Published",
  2: "Deleted",
  3: "Closed",
};

export const Career_Job_Table_Head = [
  { field: "sl_no", headerName: "Sl No", width: 80 },
  { field: "job_title", headerName: "Job Title", width: 220 },
  {
    field: "company_name",
    headerName: "Company",
    width: 180,
    valueGetter: (params) => (params.value ? params.value : ""),
  },
  {
    field: "location",
    headerName: "Location",
    width: 150,
    valueGetter: (params) => (params.value ? params.value : ""),
  },
  {
    field: "work_mode",
    headerName: "Work Mode",
    width: 120,
    valueGetter: (params) => (params.value ? params.value : ""),
  },
  {
    field: "targets",
    headerName: "Batches",
    width: 100,
    // each job carries its target rows; show how many batches it targets
    valueGetter: (params) =>
      Array.isArray(params.row?.targets) ? params.row.targets.length : 0,
  },
  {
    field: "applicant_count",
    headerName: "Applicants",
    width: 110,
    // number of students who responded (excludes "not interested")
    valueGetter: (params) => (params.row?.applicant_count != null ? params.row.applicant_count : 0),
  },
  {
    field: "vacancies",
    headerName: "Vacancies",
    width: 110,
    valueGetter: (params) => (params.value != null ? params.value : ""),
  },
  {
    field: "eligible_count",
    headerName: "Who Can Apply",
    width: 130,
    // number of students eligible (everyone in the job's target batches)
    valueGetter: (params) => (params.row?.eligible_count != null ? params.row.eligible_count : ""),
  },
  {
    field: "deadline",
    headerName: "Deadline",
    width: 130,
    valueGetter: (params) => (params.value ? params.value : ""),
  },
  {
    field: "job_status",
    headerName: "Status",
    width: 120,
    valueGetter: (params) =>
      JOB_STATUS_LABEL[params.value] != null ? JOB_STATUS_LABEL[params.value] : params.value,
  },
];
